function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m116.5 0.67765v958h-116v43h950v-43h-116l-0.99-733.3zm675 256v702h-294v-105h-44v105h-294v-900zm-529 71v43h84v-43zm171 0v43h84v-43zm171 0v43h84v-43zm-342 126v44h84v-44zm171 0v44h84v-44zm171 0v44h84v-44zm-342 129v43h84v-43zm171 0v43h84v-43zm171 0v43h84v-43zm-342 129v43h84v-43zm171 0v43h84v-43zm171 0v43h84v-43z",
  stroke: "none"
});

var SvgEtage = function SvgEtage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    width: "251.62mm",
    height: "265.16mm",
    viewBox: "0 0 951 1002.1776",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEtage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/etage.9703213b.svg";
export { ForwardRef as ReactComponent };